var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2568 2.55432C9.84006 1.87832 10.2332 0.936793 10.1256 0C9.28511 0.0320003 8.26824 0.536922 7.66556 1.21212C7.12436 1.81132 6.65193 2.76874 6.77894 3.68714C7.71653 3.75674 8.67353 3.23111 9.2568 2.55432ZM11.3593 8.50008C11.3828 10.9217 13.5759 11.7272 13.6001 11.7376C13.5823 11.7944 13.2498 12.8854 12.4449 14.0134C11.7484 14.9878 11.026 15.9583 9.88779 15.9791C8.7698 15.9991 8.40981 15.3439 7.13084 15.3439C5.85267 15.3439 5.45304 15.9582 4.39492 15.999C3.29635 16.0382 2.45907 14.9448 1.75769 13.9736C0.322591 11.9872 -0.773555 8.36015 0.698761 5.91216C1.43006 4.69697 2.73654 3.92627 4.15546 3.90707C5.23381 3.88707 6.2523 4.60239 6.91161 4.60239C7.57091 4.60239 8.80863 3.74238 10.1094 3.86879C10.6539 3.89039 12.1828 4.07912 13.1641 5.45591C13.0848 5.50311 11.3399 6.47609 11.3593 8.50008Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.af7cdafe.svg";
export { ForwardRef as ReactComponent };